import { useState, useEffect } from "react";
import notify from "./../useNotifaction";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../redux/actions/authAction";
import { validateEmail } from "../../Feature/EmailValidRegex";
import validatePassword from "../../Feature/PassworValidRegex";

const LoginHook = () => {
  const dispatch = useDispatch();
  //   const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const onChangeRememberMe = () => {
    setRememberMe(!rememberMe);
  };

  const isComplate =
    validateEmail(email).length === 0 &&
    validatePassword(password).length === 0;

  const onSubmit = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(
      loginUser({
        email,
        password,
        rememberMe,
      })
    );
    setLoading(false);
    setIsPress(false);
  };
  const res = useSelector((state) => state.authReducer.loginUser);
  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.data.error) {
          if (res.data.error.length >= 1) {
            res.data.error.forEach((e) => {
              notify(e.msg, "error");
            });
          } else {
            notify(res.data.error.message, "error");
          }
        } else if (res.data.token) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.data));
          notify("تم تسجيل الدخول بنجاح", "success");
          setTimeout(() => {
            window.location.href = "/";
          }, 1500);
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }

        if (res.data.message === "Incorrect email or password") {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          notify("كلمة السر او الايميل خطا", "error");
        }
        setLoading(true);
      }
    }
  }, [loading, res]);

  return [
    email,
    password,
    loading,
    onChangeEmail,
    onChangePassword,
    rememberMe,
    onChangeRememberMe,
    onSubmit,
    isPress,
    isComplate,
    showPassword,
    togglePasswordVisibility,
  ];
};

export default LoginHook;
